import React from 'react';
import { Box, Typography } from '@mui/material';

interface FinancialLineProps {
  label: React.ReactNode;
  value: string;
  total?: boolean;
}

export const FinancialLine: React.FC<FinancialLineProps> = ({ label, value, total = false }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto', gap: 2, alignItems: 'baseline', py: 0.5 }}>
    <Typography component="div" variant={total ? 'body1' : 'body2'} sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
      {label}
    </Typography>
    <Typography variant={total ? 'body1' : 'body2'} fontWeight={total ? 'bold' : 'medium'}
      sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>
      {value}
    </Typography>
  </Box>
);
